import { CommonModule } from '@angular/common';
import {
  Component,
  contentChild,
  EventEmitter,
  input,
  Output,
  output,
  Resource,
  ResourceStatus,
  TemplateRef,
} from '@angular/core';
import { DynamicModule } from '@softline/dynamic';
import { I18nModule, UiCorePipesModule } from '@softline/ui-core';
import { ResourceContainerComponent } from '../../components/resource-container/resource-container.component';
import { PageHeaderComponent } from '../page/page-header/page-header.component';
import { PageComponent } from '../page/page.component';
import { PageSummaryComponent } from './page-summary/page-summary.component';

@Component({
  selector: 'soft-list-page',
  imports: [
    CommonModule,
    PageComponent,
    DynamicModule,
    I18nModule,
    UiCorePipesModule,
    PageHeaderComponent,
    ResourceContainerComponent,
  ],
  templateUrl: './list-page.component.html',
  styleUrl: './list-page.component.scss',
})
export class ListPageComponent<T> {
  resourceStates = ResourceStatus;

  resource = input.required<Resource<T[] | undefined>>();
  cancelLoad = output();

  @Output() itemClick = new EventEmitter<T>();

  header = contentChild(PageHeaderComponent, { descendants: true });
  itemTemplate = contentChild<TemplateRef<{ item: T }>>(TemplateRef);
  summary = contentChild(PageSummaryComponent, { descendants: true });
}
